import React from "react";

// Todos los modulos usan el mismo color cuando estan activos.
const estiloBoton = (activo) => ({
  padding: '10px 20px',
  borderRadius: '5px',
  fontWeight: 'bold',
  cursor: 'pointer',
  border: 'none',
  transition: 'all 0.3s',
  backgroundColor: activo ? '#003b5c' : '#f0f0f0',
  color: activo ? 'white' : '#333'
});

const MenuModulos = ({ vistaActiva, setVistaActiva, setAlumnoSeleccionado, cajeroRol, casosAbiertos = 0, casosPendientes = 0 }) => {
  return (
    <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap', backgroundColor: '#fff', padding: '10px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
      <button
        onClick={() => setVistaActiva('busqueda')}
        style={estiloBoton(vistaActiva === 'busqueda')}
      >
        👨‍🎓 Módulo Alumnos
      </button>

      <button
        onClick={() => {
          setVistaActiva('externos');
          setAlumnoSeleccionado(null);
        }}
        style={estiloBoton(vistaActiva === 'externos')}
      >
        ☕ Módulo Externos
      </button>

      <button
        className={`btn-modulo ${vistaActiva === 'aspirantes' ? 'activo' : ''}`}
        onClick={() => {
          setVistaActiva('aspirantes');
          setAlumnoSeleccionado(null);
        }}
        style={estiloBoton(vistaActiva === 'aspirantes')}
      >
        📝 Módulo Aspirantes
      </button>

      <button
        onClick={() => {
          setVistaActiva('exalumnos');
          setAlumnoSeleccionado(null);
        }}
        style={estiloBoton(vistaActiva === 'exalumnos')}
      >
        🎓 Ex-alumnos
      </button>

      <button
        onClick={() => {
          setVistaActiva('reportes');
          setAlumnoSeleccionado(null);
        }}
        style={estiloBoton(vistaActiva === 'reportes')}
      >
        📊 Reportes
      </button>

      {/* Solo los cajeros (roles 2 y 3) y solo si Financieros publico casos a su plantel */}
      {["2", "3"].includes(String(cajeroRol)) && (casosAbiertos > 0 || vistaActiva === 'casos') && (
        <button
          onClick={() => {
            setVistaActiva('casos');
            setAlumnoSeleccionado(null);
          }}
          style={estiloBoton(vistaActiva === 'casos')}
        >
          ⚠️ Casos por corregir{casosPendientes > 0 ? ` (${casosPendientes})` : ""}
        </button>
      )}

      {String(cajeroRol) === "1" && (
        <button
          onClick={() => {
            setVistaActiva('usuarios');
            setAlumnoSeleccionado(null);
          }}
          style={estiloBoton(vistaActiva === 'usuarios')}
        >
          👥 Usuarios
        </button>
      )}

      {String(cajeroRol) === "1" && (
        <button
          onClick={() => {
            setVistaActiva('conciliacion');
            setAlumnoSeleccionado(null);
          }}
          style={estiloBoton(vistaActiva === 'conciliacion')}
        >
          🧾 Conciliación
        </button>
      )}
    </div>
  );
};

export default MenuModulos;
